export const CAMPAIGN_LINKS_FORM_ID = 'CAMPAIGN_LINKS_FORM_ID';
